import { useMemo } from 'react';
import { createOnboardingSx } from '../styles/layout';
import useOnboardingTheme from './useOnboardingTheme';

export default function useOnboardingSx() {
  const themeTokens = useOnboardingTheme();

  return useMemo(
    () => createOnboardingSx({ accent: themeTokens.accent, shadows: themeTokens.shadows }),
    [themeTokens.accent, themeTokens.shadows]
  );
}
